import { z } from "zod"

/** The stores selected on Nyckeltal and Trender, shared between the two. */
export const statsSearchSchema = z.object({
  storeIds: z.array(z.string().uuid()).optional().catch(undefined),
})
